import { ref } from 'vue';
import type { ITableItemsPerPageOptions } from '@/models/TableSettingsModel';

export const itemsPerPageOptions = ref<ITableItemsPerPageOptions[]>([
    {
        value: 10,
        title: '10'
    },
    {
        value: 25,
        title: '25'
    },
    {
        value: 50,
        title: '50'
    },
    {
        value: 100,
        title: '100'
    },
]);
